var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildAccountability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 59.28 62.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15735",
    "data-name": "Group 15735",
    transform: "translate(-354.609 -4598.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15735-2",
    "data-name": "Group 15735",
    transform: "translate(354.862 4635.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28211",
    "data-name": "Path 28211",
    d: "M36.786,59.248l-5.342,2.876L42.928,75.563l2.047-1.1Zm28.97,6.178,19.586-5.671a3.557,3.557,0,0,1,.1,1.617,2.993,2.993,0,0,1-1,1.818l-20.2,8.564-14.764-2.44a1.026,1.026,0,0,0-.687.128l-3.168,1.863L39.78,60.455c5.555-2.718,9.021-4.717,10.118-5.367l15.238,4a2.574,2.574,0,0,1,.1,4.259L57.25,61.367a1.032,1.032,0,1,0-.493,2l8.415,2.082a1.028,1.028,0,0,0,.583-.027ZM49.2,53.1a1.03,1.03,0,0,1,.8-.118L65.78,57.121a1.036,1.036,0,0,1,.226.088,4.37,4.37,0,0,1,2.124,5.384l17.5-5.067a1.031,1.031,0,0,1,1.208.492,5.669,5.669,0,0,1,.639,3.7,5.046,5.046,0,0,1-1.893,3.2s-.191.109-.21.117L64.815,73.749a1.026,1.026,0,0,1-.615.09L49.51,71.411,46.6,73.122l.683,1.269a1.032,1.032,0,0,1-.42,1.4l-3.689,1.986a1.032,1.032,0,0,1-1.273-.238L29.07,62.523a1.032,1.032,0,0,1,.269-1.611l7.378-3.972a1.032,1.032,0,0,1,1.4.42l.686,1.275c6.772-3.31,10.39-5.53,10.4-5.536Z",
    transform: "translate(-28.795 -52.949)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_28212",
    "data-name": "Path 28212",
    d: "M86.324,25.473h0a1.032,1.032,0,0,0-.973-.954,25.3,25.3,0,0,1-15.261-6.233,1.031,1.031,0,0,0-1.365-.007,25.325,25.325,0,0,1-7.111,4.4,25.326,25.326,0,0,1-8.11,1.838,1.033,1.033,0,0,0-1.022.957,32.1,32.1,0,0,0,3.527,17.6,36.261,36.261,0,0,0,12.82,13.554,1.031,1.031,0,0,0,1.128.013c11.008-7.021,17.368-18,16.368-31.165Zm-9.907-.887A27.4,27.4,0,0,1,69.4,20.407a27.43,27.43,0,0,1-14.916,6.105,29.922,29.922,0,0,0,3.349,15.6A34,34,0,0,0,69.4,54.54,34,34,0,0,0,80.97,42.109a29.922,29.922,0,0,0,3.349-15.6,27.391,27.391,0,0,1-7.9-1.927Z",
    transform: "translate(327.198 4580.975)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28213",
    "data-name": "Path 28213",
    d: "M66.787,36.654l9.425-8.981a.948.948,0,0,1,1.34.033l2.622,2.752a.948.948,0,0,1-.033,1.34L67.36,43.978a.948.948,0,0,1-1.324-.017l-7.194-7.2a.948.948,0,0,1,0-1.34l2.689-2.687a.948.948,0,0,1,1.34,0ZM76.834,29.7l-9.409,8.965a.948.948,0,0,1-1.325-.019l-3.9-3.9L60.855,36.1l5.87,5.869L78.148,31.081Z",
    transform: "translate(328.463 4582.17)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildAccountability);
export default __webpack_public_path__ + "static/media/BuildAccountability.bc8f41ec1aaec78ac0b1997e4311f864.svg";
export { ForwardRef as ReactComponent };